import React, { useEffect, useState } from "react";
import AdminNav from "../../../components/AdminNav/AdminNav";
import { useNavigate } from "react-router-dom";
import "./Adminteam.css";

export default function Adminteam() {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ name: "", position: "", description: "", image: null });
  const apiUrl = process.env.REACT_APP_API_URL;
  const storageUrl = process.env.REACT_APP_STORAGE_URL;
  const token = localStorage.getItem("token");

  const fetchMembers = () => {
    setLoading(true);
    fetch(`${apiUrl}/teammembers`)
      .then((res) => res.json())
      .then((data) => setMembers(Array.isArray(data) ? data : []))
      .catch(() => setMembers([]))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchMembers();
  }, [apiUrl]);

  // Drag and drop state
  const [draggingId, setDraggingId] = useState(null);
  const [dragOverId, setDragOverId] = useState(null);

  const openCreate = () => {
    setEditing(null);
    setForm({ name: "", position: "", description: "", image: null });
    setShowModal(true);
  };

  const openEdit = (member) => {
    setEditing(member.id);
    setForm({ name: member.name || "", position: member.position || "", description: member.description || "", image: null });
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setEditing(null);
    setForm({ name: "", position: "", description: "", image: null });
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Biztosan törölni szeretnéd?")) return;
    try {
      await fetch(`${apiUrl}/admin/teammembers/${id}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
        credentials: "include",
      });
      fetchMembers();
    } catch (e) {
      alert("Törlés sikertelen.");
    }
  };

  

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("name", form.name);
    formData.append("position", form.position);
    formData.append("description", form.description);
    if (form.image) formData.append("image", form.image);

    try {
      // POST to a dedicated update endpoint when editing (no _method override needed)
      const url = editing !== null ? `${apiUrl}/admin/teammembers/${editing}/update` : `${apiUrl}/admin/teammembers`;
      const res = await fetch(url, {
        method: 'POST',
        body: formData,
        headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
        credentials: 'include',
      });
      // debug log
      // eslint-disable-next-line no-console
      console.log('Adminteam submit response', res.status);
      let body = null;
      try { body = await res.json(); } catch (e) { body = null; }
      // eslint-disable-next-line no-console
      console.log('Adminteam submit body', body);
      if (res.ok) {
        closeModal();
        fetchMembers();
      } else {
        alert("Hiba történt: " + (body && body.error ? body.error : res.status));
      }
    } catch (err) {
      alert("Hiba történt.");
    }
  };

  // Drag handlers
  const onDragStart = (e, id) => {
    setDraggingId(id);
    e.dataTransfer.effectAllowed = 'move';
    try { e.dataTransfer.setData('text/plain', String(id)); } catch (_) {}
  };

  const onDragEnd = () => {
    setDraggingId(null);
    setDragOverId(null);
  };

  const onDragEnter = (e, id) => {
    e.preventDefault();
    setDragOverId(id);
  };

  const onDragLeave = (e, id) => {
    e.preventDefault();
    // clear only if leaving the current hover target
    if (dragOverId === id) setDragOverId(null);
  };

  const onDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
  };

  const onDropOn = async (e, targetId) => {
    e.preventDefault();
    const data = e.dataTransfer.getData('text/plain');
    const draggedId = data ? Number(data) : draggingId;
    if (!draggedId || draggedId === targetId) {
      setDraggingId(null);
      return;
    }

    // compute new order: move dragged element before target element
    const current = [...members];
    const draggedIndex = current.findIndex(m => m.id === draggedId);
    const targetIndex = current.findIndex(m => m.id === targetId);
    if (draggedIndex === -1 || targetIndex === -1) { setDraggingId(null); return; }

    const [draggedItem] = current.splice(draggedIndex, 1);
    // insert at targetIndex (if draggedIndex < targetIndex, targetIndex is now one less)
    const insertAt = draggedIndex < targetIndex ? targetIndex : targetIndex;
    current.splice(insertAt, 0, draggedItem);

    setMembers(current);
    setDraggingId(null);

    // persist order to server
    try {
      const res = await fetch(`${apiUrl}/admin/teammembers/reorder`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ order: current.map(m => m.id) }),
      });
      if (!res.ok) {
        alert('Sorrend mentése sikertelen.');
        fetchMembers();
      }
    } catch (e) {
      alert('Sorrend mentése sikertelen.');
      fetchMembers();
    }
  };

  return (
    <div>
      <AdminNav />
      <div className="admin-container">
        <h2>Csapat tagok kezelése</h2>
        <div style={{ marginBottom: 16 }}>
          <button className="primary-btn" onClick={openCreate}>Új tag hozzáadása</button>
        </div>

        {loading ? (
          <div>Betöltés...</div>
        ) : (
          <div className="team-list">
            {members.length === 0 ? (
              <div>Nincsenek csapattagok.</div>
            ) : members.map((m) => {
              const imgSrc = m.image ? (String(m.image).startsWith('/') ? m.image : `${storageUrl}${m.image}`) : null;
              return (
                <div
                  className={`team-item ${draggingId === m.id ? 'dragging' : ''} ${dragOverId === m.id ? 'drag-over' : ''}`}
                  key={m.id}
                  draggable={true}
                  onDragStart={(e) => onDragStart(e, m.id)}
                  onDragOver={(e) => onDragOver(e)}
                  onDrop={(e) => onDropOn(e, m.id)}
                  onDragEnd={onDragEnd}
                  onDragEnter={(e) => onDragEnter(e, m.id)}
                  onDragLeave={(e) => onDragLeave(e, m.id)}
                >
                  <div className="team-avatar">
                    {imgSrc ? <img src={imgSrc} alt={m.name} /> : <div className="avatar-placeholder" />}
                  </div>
                  <div className="team-info">
                    <div className="team-name">{m.name}</div>
                    <div className="team-position">{m.position}</div>
                    <div className="team-desc">{m.description}</div>
                  </div>
                  <div className="team-actions">
                    <div style={{display: 'flex', flexDirection: 'column', gap: 6}}>
                      <button onClick={() => openEdit(m)} className="edit-btn">Szerkesztés</button>
                      <button onClick={() => handleDelete(m.id)} className="delete-btn">Törlés</button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {showModal && (
          <div className={`modal-overlay active`}>
            <div className="modal">
              <h3>{editing ? "Tag szerkesztése" : "Új tag"}</h3>
              <form onSubmit={handleSubmit} className="team-form">
                <label>Név
                  <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
                </label>
                <label>Beosztás
                  <input required value={form.position} onChange={(e) => setForm({ ...form, position: e.target.value })} />
                </label>
                <label>Leírás
                  <textarea value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} />
                </label>
                <label>Kép
                  <input type="file" accept="image/*" onChange={(e) => setForm({ ...form, image: e.target.files[0] })} />
                </label>
                <div className="modal-actions">
                  <button type="submit" className="primary-btn">Mentés</button>
                  <button type="button" className="cancel-btn" onClick={closeModal}>Mégse</button>
                </div>
              </form>
            </div>
          </div>
        )}

      </div>
    </div>
  );
}
